import { MoveToAction } from "./utilityActions";
import { TestCase } from "./testCase";
import { SceneGraphic, SceneGroup, FillSceneGraphic } from "../api/scene";
import { NotImplementedError } from "../api/errors";
import { AxisSceneGroup } from "../api/sceneGroup";
class MoveTestCase extends TestCase {
    constructor(parameterData) {
        super(parameterData);
        //Data for model
        this._gridWidth = parameterData.gridWidth;
        this._gridHeight = parameterData.gridHeight;
        this._goalX = parameterData.goalX;
        this._goalY = parameterData.goalY;
        this._itemX = parameterData.itemX;
        this._itemY = parameterData.itemY;
        //View
        this._sceneGroup = new SceneGroup();
        //Background Fill
        let fillSceneGraphic = new FillSceneGraphic(this.canvasWidth, this.canvasHeight, "#073642");
        this._sceneGroup.add(fillSceneGraphic);
        //Axis
        if (this._parameterData.showAxis) {
            let axisSceneGroup = new AxisSceneGroup(0, this._gridWidth, 0, this._gridHeight, MoveTestCase.spaceWidth, MoveTestCase.spaceHeight, "X", "Y");
            axisSceneGroup.x = MoveTestCase.spaceWidth * 0.5;
            axisSceneGroup.y = MoveTestCase.spaceHeight * 0.5;
            this._sceneGroup.add(axisSceneGroup);
        }
        //Goal
        this._goalSceneNode = new HouseSceneNode();
        this._goalSceneNode.x = this._gridXToSceneX(this._goalX);
        this._goalSceneNode.y = this._gridYToSceneY(this._goalY);
        this._sceneGroup.add(this._goalSceneNode);
        this._itemSceneNode = new RobotSceneNode();
        this._itemSceneNode.x = this._gridXToSceneX(this._itemX);
        this._itemSceneNode.y = this._gridYToSceneY(this._itemY);
        this._sceneGroup.add(this._itemSceneNode);
    }
    static randomize(parameterData) {
        parameterData.itemX = Math.floor(Math.random() * parameterData.gridWidth);
        parameterData.itemY = Math.floor(Math.random() * parameterData.gridHeight);
        parameterData.goalX = Math.floor(Math.random() * parameterData.gridWidth);
        parameterData.goalY = Math.floor(Math.random() * parameterData.gridHeight);
    }
    static get spaceWidth() {
        return 20;
    }
    static get spaceHeight() {
        return 20;
    }
    static get millisecondsPerMove() {
        return 500;
    }
    createSceneNode() {
        return this._sceneGroup;
    }
    get canvasWidth() {
        return 100;
    }
    get canvasHeight() {
        return 100;
    }
    get isSuccess() {
        return this._itemX == this._goalX && this._itemY == this._goalY;
    }
    //This is the "world" argument that users code against.
    createRoot() {
        throw new NotImplementedError();
    }
    get goalX() {
        return this._goalX;
    }
    get goalY() {
        return this._goalY;
    }
    get itemX() {
        return this._itemX;
    }
    get itemY() {
        return this._itemY;
    }
    move(deltaX, deltaY) {
        this.dirty();
        if (isNaN(deltaX) || isNaN(deltaY)) {
            return;
        }
        if (this._canMove(this._itemX + deltaX, this._itemY + deltaY)) {
            this._itemX += deltaX;
            this._itemY += deltaY;
            this._actionQueue.add(new MoveToAction(this._itemSceneNode, this._gridXToSceneX(this._itemX), this._gridYToSceneY(this._itemY), MoveTestCase.millisecondsPerMove));
        }
        else {
            this._actionQueue.add(new MoveToAction(this._itemSceneNode, this._gridXToSceneX(this._itemX + deltaX), this._gridYToSceneY(this._itemY + deltaY), MoveTestCase.millisecondsPerMove));
            this._actionQueue.add(new MoveToAction(this._itemSceneNode, this._gridXToSceneX(this._itemX), this._gridYToSceneY(this._itemY), MoveTestCase.millisecondsPerMove));
        }
    }
    moveTo(x, y) {
        this.move(x - this._itemX, y - this._itemY);
    }
    _canMove(x, y) {
        return x >= 0 && x < this._gridWidth && y >= 0 && y < this._gridHeight;
    }
    _gridXToSceneX(gridX) {
        return gridX * MoveTestCase.spaceWidth;
    }
    _gridYToSceneY(gridY) {
        return gridY * MoveTestCase.spaceHeight;
    }
    createElement(document) {
        throw new NotImplementedError();
    }
    get styleSheet() {
        return `.move-container {
      width: 100%;
      height: 100%;
      display: flex;
      direction: column;
      align-items: center;
      justify-content: center;
    }
    .move-grid {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
    }
    .move-item {
      display: grid;
      justify-items: center;
    }
    .move_value {
      border: 2px solid var(--color-base02);
    }`;
    }
}
// prettier-ignore
class HouseSceneNode extends SceneGraphic {
    constructor() {
        super();
        this._width = 28.558;
        this._height = 23.067;
    }
    onRender(ctx) {
        // #rect875
        ctx.beginPath();
        ctx.globalAlpha = 1.0;
        //ctx.fillStyle = 'rgba(0, 0, 0, 0)';
        //ctx.strokeStyle = 'rgb(0, 43, 54)'; //Original color
        ctx.strokeStyle = 'rgb(123, 51, 45)'; //Revised color for dark background
        ctx.lineWidth = 1.00;
        ctx.miterLimit = 4;
        ctx.moveTo(0.500000, 4.999751);
        ctx.lineTo(-2.500000, 5.000000);
        ctx.lineTo(10.000000, -2.500000);
        ctx.lineTo(22.500000, 5.000000);
        ctx.lineTo(19.500000, 5.000249);
        ctx.lineTo(19.500000, 19.500000);
        ctx.lineTo(0.500000, 19.500000);
        ctx.lineTo(0.500000, 4.999751);
        //ctx.fill();
        ctx.stroke();
    }
}
// prettier-ignore
class RobotSceneNode extends SceneGraphic {
    constructor() {
        super();
        this._width = 20;
        this._height = 20;
    }
    onRender(ctx) {
        // #path841
        ctx.beginPath();
        ctx.fillStyle = 'rgb(166, 73, 66)';
        ctx.lineWidth = 1.322580;
        ctx.moveTo(9.999844, 0.000000);
        ctx.bezierCurveTo(8.988473, 0.000000, 8.131942, 0.325410, 7.833165, 0.776034);
        ctx.lineTo(12.165589, 0.776034);
        ctx.bezierCurveTo(11.867451, 0.325174, 11.010686, 0.000000, 9.999533, 0.000000);
        ctx.fill();
        // #path843
        ctx.beginPath();
        ctx.fillStyle = 'rgb(231, 158, 79)';
        ctx.lineWidth = 1.322580;
        ctx.moveTo(12.166835, 0.711753);
        ctx.lineTo(7.834411, 0.711753);
        ctx.bezierCurveTo(7.760861, 0.822251, 7.719704, 0.940002, 7.719704, 1.062622);
        ctx.lineTo(7.719704, 1.169380);
        ctx.lineTo(12.281274, 1.169380);
        ctx.lineTo(12.281274, 1.062622);
        ctx.bezierCurveTo(12.281274, 0.939744, 12.240114, 0.822009, 12.166888, 0.711753);
        ctx.fill();
        // #path845
        ctx.beginPath();
        ctx.fillStyle = 'rgb(123, 51, 45)';
        ctx.lineWidth = 1.322580;
        ctx.moveTo(10.716567, 14.520420);
        ctx.lineTo(14.834800, 14.520420);
        ctx.lineTo(14.834800, 18.303673);
        ctx.lineTo(10.716567, 18.303673);
        ctx.fill();
        // #path847
        ctx.beginPath();
        ctx.fillStyle = 'rgb(123, 51, 45)';
        ctx.lineWidth = 1.322580;
        ctx.moveTo(5.163954, 14.520420);
        ctx.lineTo(9.282499, 14.520420);
        ctx.lineTo(9.282499, 18.303673);
        ctx.lineTo(5.163954, 18.303673);
        ctx.fill();
        // #path849
        ctx.beginPath();
        ctx.fillStyle = 'rgb(166, 73, 66)';
        ctx.lineWidth = 1.322580;
        ctx.moveTo(15.386712, 19.678330);
        ctx.bezierCurveTo(15.386712, 19.856347, 15.186759, 20.000000, 14.940509, 20.000000);
        ctx.lineTo(10.612602, 20.000000);
        ctx.bezierCurveTo(10.365994, 20.000000, 10.166399, 19.856324, 10.166399, 19.678330);
        ctx.lineTo(10.166399, 18.337363);
        ctx.bezierCurveTo(10.166399, 18.159346, 10.366025, 18.015221, 10.612602, 18.015221);
        ctx.lineTo(14.940509, 18.015221);
        ctx.bezierCurveTo(15.186790, 18.015221, 15.386712, 18.159369, 15.386712, 18.337363);
        ctx.fill();
        // #path851
        ctx.beginPath();
        ctx.fillStyle = 'rgb(166, 73, 66)';
        ctx.lineWidth = 1.322580;
        ctx.moveTo(9.833476, 19.678330);
        ctx.bezierCurveTo(9.833476, 19.856347, 9.633850, 20.000000, 9.387600, 20.000000);
        ctx.lineTo(5.059382, 20.000000);
        ctx.bezierCurveTo(4.812119, 20.000000, 4.613179, 19.856324, 4.613179, 19.678330);
        ctx.lineTo(4.613179, 18.337363);
        ctx.bezierCurveTo(4.613179, 18.159346, 4.812151, 18.015221, 5.059382, 18.015221);
        ctx.lineTo(9.387600, 18.015221);
        ctx.bezierCurveTo(9.633881, 18.015221, 9.833476, 18.159369, 9.833476, 18.337363);
        ctx.fill();
        // #path853
        ctx.beginPath();
        ctx.fillStyle = 'rgb(123, 51, 45)';
        ctx.lineWidth = 1.322580;
        ctx.moveTo(4.612976, 19.168491);
        ctx.lineTo(9.833320, 19.168491);
        ctx.lineTo(9.833320, 19.585481);
        ctx.lineTo(4.612976, 19.585481);
        ctx.fill();
        // #path855
        ctx.beginPath();
        ctx.fillStyle = 'rgb(123, 51, 45)';
        ctx.lineWidth = 1.322580;
        ctx.moveTo(10.149544, 19.168491);
        ctx.lineTo(15.370200, 19.168491);
        ctx.lineTo(15.370200, 19.585481);
        ctx.lineTo(10.149544, 19.585481);
        ctx.fill();
        // #path857
        ctx.beginPath();
        ctx.fillStyle = 'rgb(138, 59, 53)';
        ctx.lineWidth = 1.199300;
        ctx.moveTo(5.928056, 3.510029);
        ctx.bezierCurveTo(5.928056, 3.976779, 5.496932, 4.355452, 4.964297, 4.355452);
        ctx.bezierCurveTo(4.431918, 4.355452, 4.000000, 3.976779, 4.000000, 3.510029);
        ctx.lineTo(4.000000, 3.066648);
        ctx.bezierCurveTo(4.000000, 2.599438, 4.431918, 2.221225, 4.964297, 2.221225);
        ctx.bezierCurveTo(5.496945, 2.221225, 5.928056, 2.599427, 5.928056, 3.066648);
        ctx.fill();
        // #path859
        ctx.beginPath();
        ctx.fillStyle = 'rgb(138, 59, 53)';
        ctx.lineWidth = 1.199300;
        ctx.moveTo(16.000000, 3.510029);
        ctx.bezierCurveTo(16.000000, 3.976779, 15.568351, 4.355452, 15.035972, 4.355452);
        ctx.bezierCurveTo(14.503324, 4.355452, 14.072213, 3.976779, 14.072213, 3.510029);
        ctx.lineTo(14.072213, 3.066648);
        ctx.bezierCurveTo(14.072213, 2.599438, 14.503337, 2.221225, 15.035972, 2.221225);
        ctx.bezierCurveTo(15.568351, 2.221225, 16.000000, 2.599427, 16.000000, 3.066648);
        ctx.fill();
        // #path861
        ctx.beginPath();
        ctx.fillStyle = 'rgb(166, 73, 66)';
        ctx.lineWidth = 1.254710;
        ctx.moveTo(16.997274, 15.666996);
        ctx.bezierCurveTo(16.997274, 15.865104, 16.760746, 16.025580, 16.469106, 16.025580);
        ctx.lineTo(3.530950, 16.025580);
        ctx.bezierCurveTo(3.239296, 16.025580, 3.002782, 15.864845, 3.002782, 15.666996);
        ctx.lineTo(3.002782, 7.137298);
        ctx.bezierCurveTo(3.002782, 6.939191, 3.239310, 6.778715, 3.530950, 6.778715);
        ctx.lineTo(16.469106, 6.778715);
        ctx.bezierCurveTo(16.760746, 6.778715, 16.997274, 6.939449, 16.997274, 7.137298);
        ctx.fill();
        // #path863
        ctx.beginPath();
        ctx.fillStyle = 'rgb(255, 238, 231)';
        ctx.lineWidth = 0.208020;
        ctx.moveTo(7.271000, 7.831210);
        ctx.bezierCurveTo(7.271000, 7.941331, 7.227255, 8.046941, 7.149388, 8.124808);
        ctx.bezierCurveTo(7.071521, 8.202675, 6.965911, 8.246420, 6.855790, 8.246420);
        ctx.bezierCurveTo(6.745669, 8.246420, 6.640059, 8.202675, 6.562192, 8.124808);
        ctx.bezierCurveTo(6.484325, 8.046941, 6.440580, 7.941331, 6.440580, 7.831210);
        ctx.bezierCurveTo(6.440580, 7.721089, 6.484325, 7.615479, 6.562192, 7.537612);
        ctx.bezierCurveTo(6.640059, 7.459745, 6.745669, 7.416000, 6.855790, 7.416000);
        ctx.bezierCurveTo(6.965911, 7.416000, 7.071521, 7.459745, 7.149388, 7.537612);
        ctx.bezierCurveTo(7.227255, 7.615479, 7.271000, 7.721089, 7.271000, 7.831210);
        ctx.fill();
        // #path865
        ctx.beginPath();
        ctx.fillStyle = 'rgb(255, 238, 231)';
        ctx.lineWidth = 0.208020;
        ctx.moveTo(13.559000, 7.831210);
        ctx.bezierCurveTo(13.559000, 7.941331, 13.515255, 8.046941, 13.437388, 8.124808);
        ctx.bezierCurveTo(13.359521, 8.202675, 13.253911, 8.246420, 13.143790, 8.246420);
        ctx.bezierCurveTo(13.033669, 8.246420, 12.928059, 8.202675, 12.850192, 8.124808);
        ctx.bezierCurveTo(12.772325, 8.046941, 12.728580, 7.941331, 12.728580, 7.831210);
        ctx.bezierCurveTo(12.728580, 7.721089, 12.772325, 7.615479, 12.850192, 7.537612);
        ctx.bezierCurveTo(12.928059, 7.459745, 13.033669, 7.416000, 13.143790, 7.416000);
        ctx.bezierCurveTo(13.253911, 7.416000, 13.359521, 7.459745, 13.437388, 7.537612);
        ctx.bezierCurveTo(13.515255, 7.615479, 13.559000, 7.721089, 13.559000, 7.831210);
        ctx.fill();
        // #path867
        ctx.beginPath();
        ctx.fillStyle = 'rgb(255, 238, 231)';
        ctx.lineWidth = 0.275134;
        ctx.moveTo(15.389828, 13.059800);
        ctx.bezierCurveTo(15.389828, 13.505516, 14.825345, 13.866906, 14.128966, 13.866906);
        ctx.lineTo(5.870223, 13.866906);
        ctx.bezierCurveTo(5.174172, 13.866906, 4.609689, 13.505527, 4.609689, 13.059800);
        ctx.lineTo(4.609689, 9.594578);
        ctx.bezierCurveTo(4.609689, 9.148390, 5.173845, 8.787000, 5.870223, 8.787000);
        ctx.lineTo(14.128966, 8.787000);
        ctx.bezierCurveTo(14.825018, 8.787000, 15.389828, 9.148390, 15.389828, 9.594578);
        ctx.fill();
        // #path869
        ctx.beginPath();
        ctx.fillStyle = 'rgb(27, 31, 58)';
        ctx.lineWidth = 0.275134;
        ctx.moveTo(14.808786, 12.799265);
        ctx.bezierCurveTo(14.808786, 13.178410, 14.304899, 13.485852, 13.683698, 13.485852);
        ctx.lineTo(6.314900, 13.485852);
        ctx.bezierCurveTo(5.694026, 13.485852, 5.189812, 13.178433, 5.189812, 12.799265);
        ctx.lineTo(5.189812, 9.853541);
        ctx.bezierCurveTo(5.189812, 9.474395, 5.694026, 9.167189, 6.314900, 9.167189);
        ctx.lineTo(13.683698, 9.167189);
        ctx.bezierCurveTo(14.304899, 9.167189, 14.808786, 9.474137, 14.808786, 9.853541);
        ctx.fill();
        // #path871
        ctx.beginPath();
        ctx.fillStyle = 'rgb(166, 73, 66)';
        ctx.lineWidth = 0.261015;
        ctx.moveTo(2.710554, 16.293627);
        ctx.bezierCurveTo(2.710554, 16.491734, 2.510477, 16.651738, 2.263477, 16.651738);
        ctx.lineTo(1.447736, 16.651738);
        ctx.bezierCurveTo(1.200413, 16.651738, 1.000070, 16.491476, 1.000070, 16.293627);
        ctx.lineTo(1.000070, 7.869602);
        ctx.bezierCurveTo(1.000070, 7.671956, 1.200735, 7.511491, 1.447736, 7.511491);
        ctx.lineTo(2.263477, 7.511491);
        ctx.bezierCurveTo(2.510800, 7.511491, 2.710554, 7.672225, 2.710554, 7.869602);
        ctx.fill();
        // #path873
        ctx.beginPath();
        ctx.fillStyle = 'rgb(123, 51, 45)';
        ctx.lineWidth = 0.261015;
        ctx.moveTo(1.000000, 10.916733);
        ctx.lineTo(2.710554, 10.916733);
        ctx.lineTo(2.710554, 12.089026);
        ctx.lineTo(1.000000, 12.089026);
        ctx.fill();
        // #path875
        ctx.beginPath();
        ctx.fillStyle = 'rgb(166, 73, 66)';
        ctx.lineWidth = 0.261015;
        ctx.moveTo(18.999299, 16.293627);
        ctx.bezierCurveTo(18.999299, 16.491734, 18.798647, 16.651738, 18.551633, 16.651738);
        ctx.lineTo(17.735906, 16.651738);
        ctx.bezierCurveTo(17.488583, 16.651738, 17.288240, 16.491476, 17.288240, 16.293627);
        ctx.lineTo(17.288240, 7.869602);
        ctx.bezierCurveTo(17.288240, 7.671956, 17.488905, 7.511491, 17.735906, 7.511491);
        ctx.lineTo(18.551633, 7.511491);
        ctx.bezierCurveTo(18.798956, 7.511491, 18.999299, 7.672225, 18.999299, 7.869602);
        ctx.fill();
        // #path877
        ctx.beginPath();
        ctx.fillStyle = 'rgb(123, 51, 45)';
        ctx.lineWidth = 0.261015;
        ctx.moveTo(17.288886, 11.035771);
        ctx.lineTo(19.000000, 11.035771);
        ctx.lineTo(19.000000, 12.208513);
        ctx.lineTo(17.288886, 12.208513);
        ctx.fill();
        // #path879
        ctx.beginPath();
        ctx.fillStyle = 'rgb(255, 238, 231)';
        ctx.lineWidth = 0.208020;
        ctx.moveTo(8.319200, 14.868280);
        ctx.bezierCurveTo(8.319200, 14.936250, 8.293164, 15.001436, 8.246820, 15.049497);
        ctx.bezierCurveTo(8.200476, 15.097559, 8.137620, 15.124560, 8.072080, 15.124560);
        ctx.bezierCurveTo(7.935599, 15.124560, 7.824960, 15.009820, 7.824960, 14.868280);
        ctx.bezierCurveTo(7.824960, 14.800310, 7.850996, 14.735124, 7.897340, 14.687063);
        ctx.bezierCurveTo(7.943684, 14.639001, 8.006540, 14.612000, 8.072080, 14.612000);
        ctx.bezierCurveTo(8.137620, 14.612000, 8.200476, 14.639001, 8.246820, 14.687063);
        ctx.bezierCurveTo(8.293164, 14.735124, 8.319200, 14.800310, 8.319200, 14.868280);
        ctx.fill();
        // #path881
        ctx.beginPath();
        ctx.fillStyle = 'rgb(255, 238, 231)';
        ctx.lineWidth = 0.208020;
        ctx.moveTo(9.604500, 14.868280);
        ctx.bezierCurveTo(9.604500, 14.936250, 9.578464, 15.001436, 9.532120, 15.049497);
        ctx.bezierCurveTo(9.485776, 15.097559, 9.422920, 15.124560, 9.357380, 15.124560);
        ctx.bezierCurveTo(9.220899, 15.124560, 9.110260, 15.009820, 9.110260, 14.868280);
        ctx.bezierCurveTo(9.110260, 14.800310, 9.136296, 14.735124, 9.182640, 14.687063);
        ctx.bezierCurveTo(9.228984, 14.639001, 9.291840, 14.612000, 9.357380, 14.612000);
        ctx.bezierCurveTo(9.422920, 14.612000, 9.485776, 14.639001, 9.532120, 14.687063);
        ctx.bezierCurveTo(9.578464, 14.735124, 9.604500, 14.800310, 9.604500, 14.868280);
        ctx.fill();
        // #path883
        ctx.beginPath();
        ctx.fillStyle = 'rgb(255, 238, 231)';
        ctx.lineWidth = 0.208020;
        ctx.moveTo(10.890000, 14.868280);
        ctx.bezierCurveTo(10.890000, 14.936250, 10.863964, 15.001436, 10.817620, 15.049497);
        ctx.bezierCurveTo(10.771276, 15.097559, 10.708420, 15.124560, 10.642880, 15.124560);
        ctx.bezierCurveTo(10.577340, 15.124560, 10.514484, 15.097559, 10.468140, 15.049497);
        ctx.bezierCurveTo(10.421796, 15.001436, 10.395760, 14.936250, 10.395760, 14.868280);
        ctx.bezierCurveTo(10.395760, 14.800310, 10.421796, 14.735124, 10.468140, 14.687063);
        ctx.bezierCurveTo(10.514484, 14.639001, 10.577340, 14.612000, 10.642880, 14.612000);
        ctx.bezierCurveTo(10.708420, 14.612000, 10.771276, 14.639001, 10.817620, 14.687063);
        ctx.bezierCurveTo(10.863964, 14.735124, 10.890000, 14.800310, 10.890000, 14.868280);
        ctx.fill();
        // #path885
        ctx.beginPath();
        ctx.fillStyle = 'rgb(255, 238, 231)';
        ctx.lineWidth = 0.208020;
        ctx.moveTo(12.175000, 14.868280);
        ctx.bezierCurveTo(12.175000, 14.936250, 12.148964, 15.001436, 12.102620, 15.049497);
        ctx.bezierCurveTo(12.056276, 15.097559, 11.993420, 15.124560, 11.927880, 15.124560);
        ctx.bezierCurveTo(11.862340, 15.124560, 11.799484, 15.097559, 11.753140, 15.049497);
        ctx.bezierCurveTo(11.706796, 15.001436, 11.680760, 14.936250, 11.680760, 14.868280);
        ctx.bezierCurveTo(11.680760, 14.800310, 11.706796, 14.735124, 11.753140, 14.687063);
        ctx.bezierCurveTo(11.799484, 14.639001, 11.862340, 14.612000, 11.927880, 14.612000);
        ctx.bezierCurveTo(11.993420, 14.612000, 12.056276, 14.639001, 12.102620, 14.687063);
        ctx.bezierCurveTo(12.148964, 14.735124, 12.175000, 14.800310, 12.175000, 14.868280);
        ctx.fill();
        // #path887
        ctx.beginPath();
        ctx.fillStyle = 'rgb(255, 238, 231)';
        ctx.lineWidth = 0.208020;
        ctx.moveTo(13.460000, 14.868280);
        ctx.bezierCurveTo(13.460000, 14.936250, 13.433964, 15.001436, 13.387620, 15.049497);
        ctx.bezierCurveTo(13.341276, 15.097559, 13.278420, 15.124560, 13.212880, 15.124560);
        ctx.bezierCurveTo(13.076399, 15.124560, 12.965760, 15.009820, 12.965760, 14.868280);
        ctx.bezierCurveTo(12.965760, 14.800310, 12.991796, 14.735124, 13.038140, 14.687063);
        ctx.bezierCurveTo(13.084484, 14.639001, 13.147340, 14.612000, 13.212880, 14.612000);
        ctx.bezierCurveTo(13.278420, 14.612000, 13.341276, 14.639001, 13.387620, 14.687063);
        ctx.bezierCurveTo(13.433964, 14.735124, 13.460000, 14.800310, 13.460000, 14.868280);
        ctx.fill();
        // #path889
        ctx.beginPath();
        ctx.fillStyle = 'rgb(255, 238, 231)';
        ctx.lineWidth = 0.208020;
        ctx.moveTo(7.033900, 14.868280);
        ctx.bezierCurveTo(7.033900, 15.009820, 6.923261, 15.124560, 6.786780, 15.124560);
        ctx.bezierCurveTo(6.721240, 15.124560, 6.658384, 15.097559, 6.612040, 15.049497);
        ctx.bezierCurveTo(6.565696, 15.001436, 6.539660, 14.936250, 6.539660, 14.868280);
        ctx.bezierCurveTo(6.539660, 14.800310, 6.565696, 14.735124, 6.612040, 14.687063);
        ctx.bezierCurveTo(6.658384, 14.639001, 6.721240, 14.612000, 6.786780, 14.612000);
        ctx.bezierCurveTo(6.923261, 14.612000, 7.033900, 14.726740, 7.033900, 14.868280);
        ctx.fill();
        // #path891
        ctx.beginPath();
        ctx.fillStyle = 'rgb(255, 238, 231)';
        ctx.lineWidth = 0.220442;
        ctx.moveTo(10.169000, 11.589801);
        ctx.lineTo(9.667460, 11.117212);
        ctx.bezierCurveTo(9.640212, 11.091742, 9.548050, 11.074222, 9.502070, 11.124912);
        ctx.bezierCurveTo(9.456302, 11.176072, 9.470032, 11.279099, 9.492270, 11.309701);
        ctx.lineTo(9.903740, 11.882282);
        ctx.bezierCurveTo(9.888760, 11.989033, 9.917050, 12.102119, 9.989866, 12.185726);
        ctx.bezierCurveTo(10.111356, 12.324494, 10.309796, 12.326369, 10.434206, 12.190426);
        ctx.bezierCurveTo(10.557566, 12.053994, 10.559236, 11.830439, 10.437906, 11.691211);
        ctx.bezierCurveTo(10.364886, 11.608041, 10.264616, 11.574172, 10.168936, 11.589827);
        ctx.fill();
        // #path893
        ctx.beginPath();
        ctx.strokeStyle = 'rgb(254, 238, 232)';
        ctx.lineWidth = 0.173450;
        ctx.lineCap = 'round';
        ctx.miterLimit = 10;
        ctx.moveTo(9.999844, 9.724509);
        ctx.lineTo(9.999844, 10.381437);
        ctx.stroke();
        // #path895
        ctx.beginPath();
        ctx.strokeStyle = 'rgb(254, 238, 232)';
        ctx.lineWidth = 0.173450;
        ctx.lineCap = 'round';
        ctx.miterLimit = 10;
        ctx.moveTo(7.673495, 10.104080);
        ctx.lineTo(8.304665, 10.673416);
        ctx.stroke();
        // #path897
        ctx.beginPath();
        ctx.strokeStyle = 'rgb(254, 238, 232)';
        ctx.lineWidth = 0.173450;
        ctx.lineCap = 'round';
        ctx.miterLimit = 10;
        ctx.moveTo(6.023989, 11.038411);
        ctx.lineTo(7.117003, 11.366303);
        ctx.stroke();
        // #path899
        ctx.beginPath();
        ctx.strokeStyle = 'rgb(254, 238, 232)';
        ctx.lineWidth = 0.173450;
        ctx.lineCap = 'round';
        ctx.miterLimit = 10;
        ctx.moveTo(12.325726, 10.104080);
        ctx.lineTo(11.694867, 10.673416);
        ctx.stroke();
        // #path901
        ctx.beginPath();
        ctx.strokeStyle = 'rgb(254, 238, 232)';
        ctx.lineWidth = 0.173450;
        ctx.lineCap = 'round';
        ctx.miterLimit = 10;
        ctx.moveTo(13.975387, 11.038411);
        ctx.lineTo(12.882062, 11.366303);
        ctx.stroke();
        // #path903
        ctx.beginPath();
        ctx.fillStyle = 'rgb(166, 73, 66)';
        ctx.lineWidth = 0.249488;
        ctx.moveTo(15.035485, 6.089658);
        ctx.bezierCurveTo(15.035485, 6.304587, 14.812725, 6.478382, 14.538010, 6.478382);
        ctx.lineTo(5.449283, 6.478382);
        ctx.bezierCurveTo(5.174287, 6.478382, 4.951808, 6.304565, 4.951808, 6.089658);
        ctx.lineTo(4.951808, 1.328951);
        ctx.bezierCurveTo(4.951808, 1.114021, 5.174313, 0.940226, 5.449283, 0.940226);
        ctx.lineTo(14.538010, 0.940226);
        ctx.bezierCurveTo(14.812712, 0.940226, 15.035485, 1.114043, 15.035485, 1.328951);
        ctx.fill();
        // #path905
        ctx.beginPath();
        ctx.fillStyle = 'rgb(255, 238, 231)';
        ctx.lineWidth = 0.286627;
        ctx.moveTo(8.933691, 3.091849);
        ctx.bezierCurveTo(8.933691, 3.832515, 8.335208, 4.431563, 7.595410, 4.431563);
        ctx.bezierCurveTo(6.854178, 4.431563, 6.256260, 3.832502, 6.256260, 3.091849);
        ctx.bezierCurveTo(6.256260, 2.354062, 6.854178, 1.755000, 7.595410, 1.755000);
        ctx.bezierCurveTo(8.335208, 1.755000, 8.933691, 2.354062, 8.933691, 3.091849);
        ctx.fill();
        // #path907
        ctx.beginPath();
        ctx.fillStyle = 'rgb(231, 158, 79)';
        ctx.lineWidth = 0.286627;
        ctx.moveTo(8.532314, 3.092400);
        ctx.bezierCurveTo(8.532314, 3.610332, 8.113273, 4.029663, 7.595327, 4.029663);
        ctx.bezierCurveTo(7.075962, 4.029663, 6.657775, 3.610332, 6.657775, 3.092400);
        ctx.bezierCurveTo(6.657775, 2.575033, 7.075962, 2.156281, 7.595327, 2.156281);
        ctx.bezierCurveTo(8.113259, 2.156281, 8.532314, 2.575033, 8.532314, 3.092400);
        ctx.fill();
        // #path909
        ctx.beginPath();
        ctx.fillStyle = 'rgb(255, 238, 231)';
        ctx.lineWidth = 0.286627;
        ctx.moveTo(13.743740, 3.091849);
        ctx.bezierCurveTo(13.743740, 3.832515, 13.145821, 4.431563, 12.406023, 4.431563);
        ctx.bezierCurveTo(11.664502, 4.431563, 11.066019, 3.832502, 11.066019, 3.091849);
        ctx.bezierCurveTo(11.066019, 2.354062, 11.664502, 1.755000, 12.406023, 1.755000);
        ctx.bezierCurveTo(13.145821, 1.755000, 13.743740, 2.354062, 13.743740, 3.091849);
        ctx.fill();
        // #path911
        ctx.beginPath();
        ctx.fillStyle = 'rgb(231, 158, 79)';
        ctx.lineWidth = 0.286627;
        ctx.moveTo(13.341398, 3.092400);
        ctx.bezierCurveTo(13.341398, 3.610332, 12.922921, 4.029663, 12.405279, 4.029663);
        ctx.bezierCurveTo(11.885914, 4.029663, 11.467134, 3.610332, 11.467134, 3.092400);
        ctx.bezierCurveTo(11.467134, 2.575033, 11.886176, 2.156281, 12.405279, 2.156281);
        ctx.bezierCurveTo(12.922935, 2.156281, 13.341398, 2.575033, 13.341398, 3.092400);
        ctx.fill();
        // #path913
        ctx.beginPath();
        ctx.fillStyle = 'rgb(255, 238, 231)';
        ctx.lineWidth = 0.286627;
        ctx.moveTo(11.868442, 4.816543);
        ctx.bezierCurveTo(11.995987, 5.054462, 11.885932, 5.361427, 11.610475, 5.464327);
        ctx.bezierCurveTo(10.572875, 5.851843, 9.429150, 5.851843, 8.391467, 5.464616);
        ctx.bezierCurveTo(8.116001, 5.362003, 8.005095, 5.054462, 8.133197, 4.816543);
        ctx.bezierCurveTo(8.261031, 4.578060, 8.526445, 4.470020, 8.734257, 4.546809);
        ctx.bezierCurveTo(9.551162, 4.851487, 10.451511, 4.851487, 11.268457, 4.546520);
        ctx.bezierCurveTo(11.475415, 4.469990, 11.740244, 4.578050, 11.868663, 4.816543);
        ctx.fill();
    }
}
export default MoveTestCase;
